const BackArrowIcon = ({ className, color = '#000000' }: { className?: string, color?: string }) => {
  return (
    <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.1938 5.27757C13.11 5.27882 13.0313 5.31382 12.9738 5.37382L6.57375 11.7738C6.44875 11.8988 6.44875 12.1013 6.57375 12.2263L12.9738 18.6263C13.0538 18.7101 13.1738 18.7438 13.285 18.7138C13.3975 18.6851 13.485 18.5976 13.5138 18.4851C13.5438 18.3738 13.51 18.2538 13.4263 18.1738L7.2525 12.0001L13.4263 5.82632C13.5213 5.73382 13.5488 5.59382 13.4975 5.47257C13.4463 5.35007 13.3263 5.27257 13.1938 5.27757Z"
        fill={color}
      />
    </svg>
  );
};

export default BackArrowIcon;
